import * as React from 'react';
import { getIsTimedPlusItemBiddingClosed, getItemSummary } from '@/redux/modules/item/summary/itemSummary.selectors';
import { isAfterStartTimeOnStartDay } from '@/utils/isAfterStartTimeOnStartDay';
import { RouteButton } from '../RouteButton/RouteButton';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import styled from 'styled-components';

type Props = {
    itemId: number;
};

const ItemBiddingSellSimilarButton = ({ itemId }: Props) => {
    const { formatMessage } = useIntl();
    const { isAvailable, isTimedPlusAuction, saleStartTs, sellerId } = useAppSelector((state) =>
        getItemSummary(state, itemId)
    );
    const isTimedPlusItemClosed = useAppSelector((state) => getIsTimedPlusItemBiddingClosed(state, itemId));

    const regularItemUnavailable = !isTimedPlusAuction && !isAvailable && !isAfterStartTimeOnStartDay(saleStartTs);
    const timedPlusItemUnavailable = isTimedPlusAuction && isTimedPlusItemClosed;
    const isItemUnavailable = regularItemUnavailable || timedPlusItemUnavailable;

    return isItemUnavailable ? (
        <StyledRouteButton
            to={`/consignments/${sellerId}`}
            variant="outlined"
        >
            {formatMessage({ id: 'sell_similar_item' })}
        </StyledRouteButton>
    ) : null;
};

export default ItemBiddingSellSimilarButton;

const StyledRouteButton = styled(RouteButton)`
    min-width: 100%;
`;
